import { Box, Button, Dialog as MUIDialog, Select as SelectMui, styled } from '@mui/material';

export const Dialog = styled(MUIDialog)({
  '& .MuiDialog-paper': {
    width: '80%',
    padding: '48px',
    maxWidth: '700px',
    backgroundColor: '#fff'
  },
  '& .MuiDialogContent-root': {
    marginTop: '24px',
    marginBottom: '24px'
  },
  '& .MuiFormControlLabel-root': {
    marginTop: '10px'
  },
  a: {
    textDecoration: 'underline',
    '&:hover': {
      textDecoration: 'none'
    }
  }
});

export const DialogPin = styled(Dialog)(({ style }) => ({
  '& .MuiDialog-paper': {
    maxWidth: '500px',
    minHeight: style?.minHeight || '738px'
  },
  '& .MuiDialogContent-root': {
    display: 'flex',
    flexDirection: 'column'
  }
}));

export const DialogAddForm = styled(Dialog)({
  '& .MuiDialog-paper': {
    maxWidth: '1024px',
    minHeight: '760px'
  }
});

export const CenterContent = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginTop: '24px',
  '& .MuiCircularProgress-root': {
    color: '#089af7'
  }
});

export const PinDisplay = styled('div')({
  marginTop: '20px',
  fontWeight: 500,
  fontSize: '40px',
  lineHeight: '48px',
  textAlign: 'center',
  letterSpacing: '40px',
  paddingLeft: '40px'
});

export const YourPinWrapper = styled('div')({
  marginBottom: '40px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  textAlign: 'center',
  marginTop: '40px',
  flex: 1
});

export const ButtonsWrapper = styled('div')({
  display: 'flex',
  justifyContent: 'flex-end',
  '& button': {
    marginLeft: '15px'
  }
});

export const Select = styled(SelectMui)({
  width: 300,
  height: 40
});

export const SelectPatientContainer = styled('div')({
  marginTop: 28
});

export const CancelButton = styled(Button)({
  backgroundColor: '#EBF3FA',
  paddingLeft: '16px',
  paddingRight: '16px',
  '&:hover': {
    backgroundColor: '#EBF3FA'
  }
});
